import { render, staticRenderFns } from "./ReviewModifyServices.vue?vue&type=template&id=345d7344&scoped=true"
import script from "./ReviewModifyServices.vue?vue&type=script&lang=js"
export * from "./ReviewModifyServices.vue?vue&type=script&lang=js"
import style0 from "./ReviewModifyServices.vue?vue&type=style&index=0&id=345d7344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345d7344",
  null
  
)

export default component.exports